import CustomCard from '../../../../components/CustomCard';
import { EmailSubsectionChip, PersonChip, PhoneSubsectionChip } from '../../../../components/buttons/IconButtons';
import CustomTooltip from '../../../../components/CustomTooltip';
import NotInformation from '../../../../components/NotInformation';
import React from "react";
import CustomSearch from "../../../../components/SearchSimples/CustomSearch";
/**
 * @Author: Susana García Rodríguez
 * @JobTitle: Frontend - IBL
 * @Email: sgarcia@ibl.mx
 */
const UserReservationCards = ({ t, currentTab, results, searchElement, setSearchElement, getActionsButtons, attendeesRef }) => {

    return (
        <>
            <div className="row mt-4 flex-shrink-0">
                <div className={"col-12 px-0"}>
                    <CustomSearch
                        id={"txt_urc_search_simple"}
                        label={'search_by_name_email_or_phone'}
                        value={searchElement}
                        setValue={setSearchElement}
                        onChange={(e) => setSearchElement(e.target.value)}
                        onReset={()=> setSearchElement("")}
                    />
                </div>
            </div>

            {results && results.length > 0 ? (
                <div className="flex-grow-1 min-h-0 overflow-y-auto" ref={attendeesRef}>
                    <div className="row">
                        {
                            results.map((user, index) => (
                                <div className='col-12 col-md-6 mb-3 px-1' key={user?.id}>
                                    <CustomCard classes='w-100 background-shades-50 border-radius-8px' classCard={"border-radius-8px"}>
                                        <div className='row'>
                                            <div className='d-flex flex-grow-1 minw-0 justify-content-between align-items-center p-0'>
                                                <div className={"mr-2"}>
                                                    <PersonChip/>
                                                </div>
                                                <div className={'flex-grow-1 minw-0'}>
                                                    <CustomTooltip
                                                        text={user?.visitorFullName}
                                                        classes={`fs-14px font-color-general-950 ibl-font-w-600 text-ellipsis-1-row`}
                                                        showIfTruncated={true}
                                                    />
                                                </div>
                                                <div className={"d-flex align-content-end"}>{getActionsButtons(user, index)}</div>
                                            </div>

                                            <div className='border-bottom-shades-300 my-2' />

                                            <div className='d-flex align-items-center justify-content-between gap-3 p-0'>
                                                <div className='d-flex flex-grow-1 minw-0 align-items-center'>
                                                    <div className={"mr-2"}>
                                                        <EmailSubsectionChip/>
                                                    </div>
                                                    <div className={'flex-grow-1 minw-0'}>
                                                        <CustomTooltip
                                                            text={user?.visitorEmail}
                                                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row p-0`}
                                                            showIfTruncated={true}
                                                            tooltipClasses={"p-0"}
                                                        />
                                                    </div>
                                                </div>

                                                <div className='d-flex flex-grow-1 minw-0 align-items-center'>
                                                    <div className={"mr-2"}><PhoneSubsectionChip/></div>
                                                    <div className={'flex-grow-1 minw-0'}>
                                                        <CustomTooltip
                                                            text={user?.visitorPhoneNumber}
                                                            classes={`fs-14px font-color-general-950 text-ellipsis-1-row p-0`}
                                                            showIfTruncated={true}
                                                            tooltipClasses={"p-0"}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </CustomCard>
                                </div>
                            ))
                        }
                    </div>
                </div>)
                : (
                    <NotInformation
                        text={searchElement === "" ? `${t('no_invitations_for')} ${t(currentTab?.translation).toLowerCase()}.`: t("no_results_found")}
                        card={true}
                        className={"h-100"}
                    />
            )}
        </>
    );
};

export default UserReservationCards;
